import type { Model } from '@patsnap/tahiti-core';
import type { EmbodimentHistoryState } from '../types';

export const EmbodimentHistoryModel = Symbol.for('EmbodimentHistoryModel');

export interface EmbodimentHistoryModel extends Model<EmbodimentHistoryState> {}
